export default "__VITE_ASSET__CcfxeHOI__"